<template>
    <aside v-show="itemsCount">
        <div class="w-100 d-flex align-items-center justify-content-center">
            <nav aria-label="Pagination" class="w-100 d-flex flex-column flex-lg-row align-items-center justify-content-center">
                <ul v-show="pageCount > 1" class="pagination mb-0">

                    <!-- go to the first page -->
                    <li :class="['page-item', isFirstPage ? 'disabled' : '']">
                        <a class="page-link" href="#" aria-label="First" @click.prevent="pageChange(1)">
                            <span aria-hidden="true">
                                <svg class="icon-chevron-double">
                                    <use xlink:href="#icon-chevron-double-left"></use>
                                </svg>
                            </span>
                        </a>
                    </li>

                    <!-- go one page back -->
                    <li :class="['page-item', isFirstPage ? 'disabled' : '']">
                        <a class="page-link" href="#" aria-label="Previous" @click.prevent="pageChange(--currentPage)">
                            <span aria-hidden="true">
                                <svg class="icon-chevron">
                                    <use xlink:href="#icon-chevron-left"></use>
                                </svg>
                            </span>
                        </a>
                    </li>

                    <!-- previous range placeholder -->
                    <li class="page-item disabled" v-show="!isFirstPage">
                        <a class="page-link" href="#">
                            <span aria-hidden="true">
                                ...
                            </span>
                        </a>
                    </li>

                    <!-- pages loop -->
                    <template v-for="number in pageCount" :key="number">
                        <li class="page-item" v-show="isInRange(number)">
                            <a :class="['page-link', number === currentPage ? 'active' : '']" @click.prevent="pageChange(number)">
                                {{number}}
                            </a>
                        </li>
                    </template>

                    <!-- next range placeholder -->
                    <li class="page-item disabled" v-show="!isLastPage">
                        <a class="page-link" href="#">
                            <span aria-hidden="true">
                                ...
                            </span>
                        </a>
                    </li>

                    <!-- go to the next page -->
                    <li :class="['page-item', isLastPage ? 'disabled' : '']">
                        <a class="page-link" href="#" aria-label="Next" @click.prevent="pageChange(++currentPage)">
                            <span aria-hidden="true">
                                <svg class="icon-chevron">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </span>
                        </a>
                    </li>

                    <!-- go to the last page -->
                    <li :class="['page-item', isLastPage ? 'disabled' : '']">
                        <a class="page-link" href="#" aria-label="Last" @click.prevent="pageChange(pageCount)">
                            <span aria-hidden="true">
                                <svg class="icon-chevron-double">
                                    <use xlink:href="#icon-chevron-double-right"></use>
                                </svg>
                            </span>
                        </a>
                    </li>
                </ul>

                <div class="ms-lg-4 mt-4 mt-lg-0">
                    <vSelect  
                        style="width: 180px;"
                        class=""
                        :options="perPageOptions" 
                        v-model="perPage" 
                        @option:selected="perPageChange(perPage)" 
                        :clearable="false"
                        :searchable="false"
                        :reduce="option => option.value" 
                        label="label"
                    ></vSelect>
                </div>

            </nav>
        </div>
    </aside>

</template>

<script>
// number of pages that will be shown around the current page
const showPagesRange = 1;

import vSelect from 'vue-select';
import { translate } from '@/scripts/mixins/translations';

export default {
    props: {
        currentPage: Number,
        perPage: Number,
        itemsCount: Number
    },
    emits: [
        'update:current-page', 
        'update:per-page'
    ],
    mixins: [
        translate
    ],
    components: {
        vSelect
    },
    data(){
        return {
            perPageOptions: [
                {
                    label: `10 ${this.translate('per page')}`,
                    value: 10
                },
                {
                    label: `20 ${this.translate('per page')}`,
                    value: 20
                },
                {
                    label: `30 ${this.translate('per page')}`,
                    value: 30
                },
            ]
        }
    },
    mounted(){
        this.syncQueryParams();
    },
    methods: {
        isInRange(pageNumber){
            // check wheter showing number is in range showPagesRange around the current page
            return (pageNumber >= this.currentPage - showPagesRange) && (pageNumber <= this.currentPage + showPagesRange);
        },
        pageChange(newPage){
            // update current page in prop model
            this.$emit('update:current-page', parseInt(newPage));

            // set value to url
            const url = new URL(window.location);
            url.searchParams.set('current-page', newPage);
            window.history.pushState({}, '', url);

            // scroll to list (if wrapper has attribute)
            const scrollToContainer = document.querySelector('[data-pagination-change-scroll-to]');
            if ( scrollToContainer )
            {
                window.scrollTo({
                    top: scrollToContainer.getBoundingClientRect().top + window.scrollY - (document.querySelector('.MainHeader').getBoundingClientRect().height + 50), 
                    behavior: 'smooth'
                });
            }
        },
        perPageChange(option){
            // update per page in prop model
            this.$emit('update:per-page', parseInt(option));

            // set value to local storage 
            // (one setting influences all of the lists)
            localStorage.setItem('list-per-page', option);

            // set value to url
            /*
            const url = new URL(window.location);
            url.searchParams.set('per-page', option);
            window.history.pushState({}, '', url);*/
        },
        syncQueryParams(){
            // parse current page and per page from url
            const url = new URL(window.location);
            let currentPage = url.searchParams.get('current-page');
            let perPage = url.searchParams.get('per-page');

            if ( currentPage ){
                this.pageChange(currentPage);
            }

            if ( perPage ){
                this.perPageChange(perPage);
            }
        }
    },  
    computed: {
        pageCount(){
            let numberOfPages = Math.ceil(this.itemsCount / this.perPage);
            return numberOfPages;
        },
        isFirstPage(){
            return this.currentPage === 1;
        },
        isLastPage(){
            return this.pageCount <= this.currentPage;
        }
    },
    watch: {
        itemsCount(newValue, oldValue){
            if ( oldValue !== 0 )
            {
                this.pageChange(1);
            }
        },
        perPage(){
            this.pageChange(1);
        }
    }
}
</script>